import { Team } from './my-team-hook';
import { Storage } from "./storage";

export { Team };

export const opponentsStorage = new Storage<Team[]>('/api/opponents', 'opponents', [], false);
